export default __webpack_public_path__ + "static/media/failedStatus.7c6d0062.svg";